import tokenService from "@/services/TokenService";
import Vapor from 'laravel-vapor'
// eslint-disable-next-line no-unused-vars
import axios from "axios";
import AuthenticationService from "@/services/AuthenticationService";

const FileService = {
    async listFiles(router, store) {
        const config = tokenService.getConfig(router, store);
        return await axios.get(process.env.VUE_APP_API_BASE_URL + '/api/files', config)
            .then(response => {
                return {
                    status: 'success',
                    files: response.data,
                };
            })
            .catch(error => {
                console.error('Error loading files:', error.response || error);
                return {
                    status: 'error',
                    message: error.response?.data?.message
                };
            });
    },

    async listFilesPaginated(router, store, page = 1, perPage = 10) {
        const config = tokenService.getConfig(router, store);
        return await axios.get(process.env.VUE_APP_API_BASE_URL + '/api/files/paginated?page=' + page + '&perPage=' + perPage, config)
            .then(response => {
                return {
                    status: 'success',
                    files: response.data.files,
                    pagination: response.data.pagination,
                };
            })
            .catch(error => {
                console.error('Error loading files:', error.response || error);
                return {
                    status: 'error',
                    message: error.response?.data?.message
                };
            });
    },

    async searchFiles(router, store, page = 1, limit = 10, searchValue = null, sortArray = []) {
        const config = tokenService.getConfig(router, store);
        const payload = {
            search: searchValue ? { value: searchValue } : null,
            sort: sortArray && sortArray.length > 0 ? sortArray : []
        };

        return await axios.post(
            process.env.VUE_APP_API_BASE_URL + '/api/files/search?page=' + page + '&limit=' + limit,
            payload,
            config
        )
            .then(response => {
                return {
                    status: 'success',
                    files: response.data.files,
                    pagination: response.data.pagination,
                };
            })
            .catch(error => {
                console.error('Error searching files:', error.response || error);
                return {
                    status: 'error',
                    message: error.response?.data?.message
                };
            });
    },

    async countFiles(router, store) {
        const config = tokenService.getConfig(router, store);
        return await axios.get(process.env.VUE_APP_API_BASE_URL + '/api/files/count', config)
            .then(response => {
                return {
                    status: 'success',
                    count: response.data.count,
                };
            })
            .catch(error => {
                console.error('Error counting files:', error.response || error);
                return {
                    status: 'error',
                    message: error.response?.data?.message
                };
            });
    },

    // eslint-disable-next-line no-unused-vars
    async uploadFile(router, store, file, contractId, schoolId) {
        try {
            const token = store.getters.userToken;
            // if token is null, return to login page
            if (!token) {
                // eslint-disable-next-line no-unused-vars
                throw {
                    response: {
                        status: 401,
                        data: {
                            message: 'Token is invalid or expired'
                        }
                    }
                };
            }

            // eslint-disable-next-line no-unused-vars
            const config = tokenService.getConfig(router, store);

            // Step 1: Get signed-storage-url
            const options = {
                baseURL: process.env.VUE_APP_API_BASE_URL,
                signedStorageUrl: '/vapor/signed-storage-url',
                headers: {
                    Authorization: `Bearer ${token}`,
                },
            };



            const response = await Vapor.store(file, options);




            // Step 2: Upload file to S3
            const uploadResponse = await axios.post(process.env.VUE_APP_API_BASE_URL + '/api/files/upload-s3', {
                name: file.name,
                uuid: response.uuid,
                bucket: response.bucket,
                key: response.key,
                url: response.url,
                contract_id: contractId,
                school_id: schoolId,
            }, config);

            const cloudFileId = uploadResponse.data.id;

            // Step 3: Validate file
            const validateResponse = await axios.post(process.env.VUE_APP_API_BASE_URL + '/api/files/validate', {
                fileId: cloudFileId,
            }, config);

            if (validateResponse.status === 200) {
                return {
                    status: 'success',
                    id: cloudFileId,
                };
            } else {
                return {
                    status: 'error',
                    message: validateResponse.data.message,
                };
            }


        } catch (error) {
            //handle disabled user error.
            if (error.response.status === 403 && error.response.data.message === 'User access is disabled by the admin') {
                return AuthenticationService.disable(store, router);
            }

            if (error.response.status === 401) {
                AuthenticationService.logoutByTimeout(router, store, true);
            }

            return {
                status: 'error',
                message: error.response?.data?.message || 'Unknown error',
            };
        }
    },
};

export default FileService;